import { render, staticRenderFns } from "./PackageContentAdult.vue?vue&type=template&id=26279a55&scoped=true&"
import script from "./PackageContentAdult.vue?vue&type=script&lang=ts&"
export * from "./PackageContentAdult.vue?vue&type=script&lang=ts&"
import style0 from "./PackageContentAdult.vue?vue&type=style&index=0&id=26279a55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26279a55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VContainer,VImg})
